











































































import { DocumentsFormStepConfiguration } from '@/api/interfaces/configuration/form/steps/documentsFormStepConfiguration';
import { DocumentsFormStepContent } from '@/api/interfaces/content/form/steps/documentsFormStepContent';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormFileUpload from '@/components/molecules/formFileUpload/FormFileUpload.vue';
import { DocumentsFormStep } from '@/types/forms/formSteps/documentsFormStep';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import Vue, { PropType } from 'vue';
import { ValidationGroups, ValidationProperties } from 'vue/types/vue';
import { Validation } from 'vuelidate';

export default Vue.extend({
    name: 'DocumentsFormStorageSection',
    components: {
        FormField,
        FormFileUpload,
    },
    props: {
        model: {
            type: Object as PropType<DocumentsFormStep>,
            required: true,
        },
        formModel: {
            type: Object as PropType<ApplicationForm>,
            required: true,
        },
        content: {
            type: Object as PropType<DocumentsFormStepContent>,
            required: true,
        },
        validations: {
            type: Object as PropType<
                | (Validation &
                      ValidationGroups &
                      ValidationProperties<DocumentsFormStep>)
                | null
            >,
            required: true,
        },
        configuration: {
            type: Object as PropType<DocumentsFormStepConfiguration>,
            required: true,
        },
        showSummary: {
            type: Boolean,
            required: true,
        },
    },
});
